CntrlServiceReceipt.$inject = [
    '$rootScope',
    '$scope',
    '$timeout',
    '$stateParams',
    '$interval',
    'PortalApi',
    'Notification',
    'Authentication',
    'Analytics',
    'Locations',
    '$translate',
    'staticCategories',
    '$state',
    'Localization',
    'Pay'
];

function CntrlServiceReceipt($rootScope, $scope, $timeout, $stateParams, $interval, PortalApi, Notification, Authentication, Analytics, Locations, $translate, staticCategories, $state, Localization, Pay) {
    var BigNumber = require('bignumber.js');

    var count = 0;
    var maxCount = 5;

    $scope.pay = Pay;
    Pay.data.load = "stepOne";
    Pay.data.preLoader = true;
    $scope.whatFrame = Authentication.frameLogin;
    $scope.paymentId = $stateParams.payment_id;
    $scope.service_id = Pay.data.serviceId;
    $scope.state = '';
    $scope.autoCheck = $stateParams.autoCheck;
    $scope.showPrintForm = false;
    $scope.showMinimizedVersion = false;
    $scope.payment = {
        status: ''
    };

    $rootScope.servicePage = true;

    if(!Pay.data.searchServices){
        $state.go('pages.services');
    }else{
        $scope.serviceId = Pay.data.searchServices.id;
        $scope.service_furl = Pay.data.searchServices.furl;
        $scope.toService = function() {

            var data = {
                serviceId: $scope.serviceId,
                url: $scope.serviceId,
                fields: [],
                amount: 0,
                autoCheck: false
            };

            Pay.data.preLoader = true;
            $state.go('pages.service', data);
        };

        $scope.rePay = function (payment) {
            $state.go('pages.service', {
                serviceId: $scope.service_id,
                url: $scope.service_furl || $scope.serviceId,
                amount: payment.amount,
                fields: payment.fields,
                templateId:true,
                autoCheck: false
            });
        };

        function leave() {
            window.top.close();
        }

        function getGaTrnName(paymentId) {
            var prefix = [];
            var app = 'PH';
            var opt = 'JD';

            if ($rootScope.admitad_uid) {
                app = 'ADMD';
            }

            if ($rootScope.useFrame) {
                app = 'F';
                opt = String(Authentication.frameLogin).replace(/[^A-z]/g, '').toUpperCase();

            } else if (Authentication.isLogged) {
                opt = 'AUTH';
            }

            prefix.push(app);
            prefix.push(opt);
            prefix.push(paymentId);

            return prefix.join('_');
        }

        $scope.getStatus = function() {

            Pay.data.preLoader = true;

            PortalApi.getPaymentStatus(
                [$stateParams.payment_id]
            ).then(function(response) {

                var response = response.plain(); //[0][1];

                var status = '';
                count++;
                $scope.payment.status = '';

                var errorText = response && !Array.isArray(response)
                    && (response.error_text || (response.data && response.data.error_text));
                if (errorText) {
                    $scope.payment.status = 'failed';
                    $scope.succ = false;
                    Pay.data.preLoader = false;
                    Pay.apiError(errorText, 10);
                    return;
                }

                if (!Array.isArray(response)
                    || !response.length
                    || ['failed', 'reverted', 'reverted_failed'].indexOf(response[0][1]) !== -1
                ) {
                    $scope.payment.status = 'failed';
                    $scope.succ = false;
                    Pay.data.preLoader = false;

                    //TODO: directive for timer
                    $scope.came = 10;
                    $scope.avail = false;
                    $scope.time = {};
                    $scope.time.s = "00";
                    $scope.time.m = "0";

                    $scope.tick = function() {
                        if ($scope.came == 0) {
                            $interval.cancel($scope.timer);
                            $scope.avail = true;
                        }
                        $scope.came--;
                        $scope.time.s = ($scope.came % 60) < 10 ? "0" + $scope.came % 60 : $scope.came % 60
                    };

                    $scope.timer = $interval($scope.tick, 1000);
                    Localization.notifyTemplate('error', 'DICTIONARY.ERROR_', 5, true, $stateParams.payment_id);
                }

                status = response[0][1];
                if (count >= maxCount) {
                    $scope.payment.status = 'error';

                    $scope.succ = false;
                    return $translate('NOTIFICATION.ERROR.MAX_TRY_STATUS').then(function(transform1) {
                        return $scope.apiError(transform1);
                    });
                } else {
                    $scope.payment.status = 'processing';
                    switch (status) {
                        case 'processing':
                        case 'confirmed':
                            return $timeout(function() {
                                $scope.getStatus();
                            }, 2000);
                            break;
                        case 'processed':
                            $scope.payment.status = 'processed';
                            $scope.getReceipt();

                            $rootScope.lastPayment = {
                                id: $stateParams.payment_id,
                                category_id: $stateParams.category_id,
                                category_name: $stateParams.category_name
                            };
                            break;
                        default:
                            $scope.payment.status = 'failed';

                            $scope.preLoader = false;
                            // $.notify('Сталася помилка');
                            $translate('ERRORS.UNKNOWN_ERROR').then(function (translation) {
                                Notification.error({
                                    message: translation,
                                    delay: true
                                });
                            });
                            break;
                    }
                }
                Pay.data.preLoader = false;
            });

            if($scope.service_id == 97033) {
                $rootScope.hideHeader = true;
                $rootScope.hideFooter = true;
                $scope.showMinimizedVersion = true;
            }
        };

        $scope.getReceipt = function() {
            PortalApi.getPaymentReceipt($stateParams.payment_id).then(function(response) {
                var response = response.plain();

                if (typeof(response) != "object" || response.status === 'error') {
                    $scope.succ = false;
                    return $translate('NOTIFICATION.ERROR.MAX_TRY').then(function(transform1) {
                        return $scope.apiError(
                            transform1,
                            true
                        );
                    });

                }

                $scope.succ = true;
                Pay.data.preLoader = false;
                $scope.payment = response;

                Analytics.addProduct(
                    String($stateParams.payment_id),
                    response.name,
                    '',
                    '',
                    '',
                    new BigNumber(response.amount).toFixed(2),
                    '1'
                );

                Analytics.trackTransaction(
                    getGaTrnName($stateParams.payment_id),
                    'PAYHUB',
                    new BigNumber(response.amount).plus(response.commission || 0).toFixed(2),
                    new BigNumber(response.commission || 0).toFixed(2),
                    '0'
                );

                Analytics.pageView();

                if (response.confirm_data.CH2) {
                    $scope.payment.name_to  = response.confirm_data.CH2.receiver;
                }
            });
        };

        $scope.apiError = function(errorText) {
            Pay.data.preLoader = false;

            return $translate('NOTIFICATION.ERROR.UNKNOWN_ERROR').then(function(transform1) {
                Notification.error({
                    message: errorText || transform1,
                });
            });

        };

        $scope.getStatus();
    }
}

module.exports = CntrlServiceReceipt;



/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/serviceReceipt/controllers/receipt.controller.js
 ** module id = 290
 ** module chunks = 1
 **/